import AxiosClient from "../../../services/axios.services";

class FactorQuestionServices {
  getFactorQuestion = (params) =>
    AxiosClient.get("/api/app/evaluacion_plantilla_factor/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getFactorQuestionById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_plantilla_factor/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveFactorQuestion = (data) =>
    AxiosClient.post("/api/app/evaluacion_plantilla_factor/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editFactorQuestion = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_plantilla_factor/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFactorQuestion = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_plantilla_factor/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new FactorQuestionServices();
